export default "__VITE_ASSET__BDvCvBQe__"